<template>
  <b-container>
    <b-row>
      <b-col>
        <h1>{{ helpImport.title }}</h1>
        <div class="WarningBeta">
          <p>{{ helpImport.introduction.sentence_1 }}</p>
          <p>{{ helpImport.introduction.sentence_2 }}</p>
          <p>{{ helpImport.introduction.sentence_3 }}</p>
        </div>
        <p>{{ helpImport.general.sentence_1}}</p>
        <ol>
          <li>{{ helpImport.general.step_1 }}</li>
          <li>{{ helpImport.general.step_2 }}</li>
          <li>{{ helpImport.general.step_3 }}</li>
          <li>{{ helpImport.general.step_4 }}</li>
        </ol>
        <p>{{ helpImport.general.sentence_2 }}</p>
        <b-tabs>
          <b-tab :title="$t(helpImport.polar.name)" active>
            <img src="../../../../assets/img/noticeHelpImport/polar-logo.jpg" width="100%" />
            <div class="TextWithLink Step">
              <p>{{ helpImport.polar.step_1 }}</p>
              <span style="margin-left: 4px"></span>
              <b-link href="https://flow.polar.com/">https://flow.polar.com/</b-link>
            </div>
            <div class="Step">
              <p>{{ helpImport.polar.step_2 }}</p>
              <img src="../../../../assets/img/noticeHelpImport/Polar_step_2.png" width="65%" />
            </div>
            <div class="Step">
              <p>{{ helpImport.polar.step_3 }}</p>
              <img src="../../../../assets/img/noticeHelpImport/Polar_step_3.png" width="65%" />
            </div>
            <div class="Step">
              <p>{{ helpImport.polar.step_4 }}</p>
              <img src="../../../../assets/img/noticeHelpImport/Polar_step_4.png" width="65%" />
            </div>
            <div class="Step">
              <p>{{ helpImport.polar.step_5 }}</p>
            </div>
            <div class="Step">
              <p>{{ helpImport.polar.step_6 }}</p>
              <img src="../../../../assets/img/noticeHelpImport/import_button.png" width="20%" />
            </div>
          </b-tab>
          <b-tab :title="$t(helpImport.connect.name)">
            <img src="../../../../assets/img/noticeHelpImport/Garmin-connect-logo.jpg" width="100%" />
            <div class="TextWithLink Step">
              <p>{{ helpImport.connect.step_1 }}</p>
              <span style="margin-left: 4px"></span>
              <b-link href="https://connect.garmin.com/signin/">https://connect.garmin.com/signin/</b-link>
            </div>
            <div class="Step">
              <p>{{ helpImport.connect.step_2 }}</p>
            </div>
            <div class="Step">
              <p>{{ helpImport.connect.step_3 }}</p>
            </div>
            <div class="Step">
              <p>{{ helpImport.connect.step_4 }}</p>
            </div>
            <div class="Step">
              <p>{{ helpImport.connect.step_5 }}</p>
            </div>
            <div class="TextWithIconInline Step">
              <p>{{ helpImport.connect.step_6_1 }}</p>
              <img src="../../../../assets/img/noticeHelpImport/connect_icon_param.png" height="14px"/>
              <p>{{ helpImport.connect.step_6_2 }}</p>
            </div>
            <div class="Step">
              <p>{{ helpImport.connect.step_7 }}</p>
            </div>
            <div class="Step">
              <p>{{ helpImport.connect.step_8 }}</p>
            </div>
            <div class="Step">
              <p>{{ helpImport.connect.step_9 }}</p>
              <img src="../../../../assets/img/noticeHelpImport/import_button.png" width="20%" />
            </div>
          </b-tab>
          <b-tab :title="$t(helpImport.suunto.name)">
            <img src="../../../../assets/img/noticeHelpImport/Suunto-logo.png" width="100%" />
            <div class="Step">
              <p>{{ helpImport.suunto.step_1 }}</p>
            </div>
            <div class="Step">
              <p>{{ helpImport.suunto.step_2 }}</p>
              <img src="../../../../assets/img/noticeHelpImport/Suunto_step_2.png" width="35%" />
            </div>
            <div class="Step">
              <p>{{ helpImport.suunto.step_3 }}</p>
              <img src="../../../../assets/img/noticeHelpImport/Suunto_step_3.png" width="35%" />
            </div>
            <div class="Step">
              <p>{{ helpImport.suunto.step_4 }}</p>
              <img src="../../../../assets/img/noticeHelpImport/import_button.png" width="20%" />
            </div>
          </b-tab>
          <b-tab :title="$t(helpImport.strava.name)">
            <img src="../../../../assets/img/noticeHelpImport/strava-logo.jpg" width="100%" />
            <div class="Step">
              <p>{{ helpImport.strava.step_1 }}</p>
            </div>
            <div class="Step">
              <p>{{ helpImport.strava.step_2 }}</p>
              <img src="../../../../assets/img/noticeHelpImport/strava_step_3_1.png" width="65%" />
            </div>
            <div class="Step">
              <p>{{ helpImport.strava.step_3_1 }}</p>
              <img src="../../../../assets/img/noticeHelpImport/strava_step_3_1.png" width="65%" />
            </div>
            <div class="Step">
              <p>{{ helpImport.strava.step_3_2 }}</p>
              <img src="../../../../assets/img/noticeHelpImport/strava_step_3_2.png" width="65%" />
            </div>
            <div class="Step">
              <p>{{ helpImport.strava.step_4 }}</p>
              <img src="../../../../assets/img/noticeHelpImport/strava_step_4.png" width="65%" />
            </div>
            <div class="Step">
              <p>{{ helpImport.strava.step_5 }}</p>
            </div>
            <div class="Step">
              <p>{{ helpImport.strava.step_6 }}</p>
              <img src="../../../../assets/img/noticeHelpImport/import_button.png" width="20%" />
            </div>
          </b-tab>
        </b-tabs>
        <div style="margin-top: 30px"></div>
        <div class="share-panel-btm">
          <b-icon class="icon-all" icon="exclamation-triangle"></b-icon>
          <div class="share-panel-btm-war">
            <p>{{ helpImport.general.help }}</p>
          </div>
          <a href="mailto:gregoire@spomo.io">
            <b-icon class="icon-all" icon="envelope"></b-icon>
          </a>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  data(){
    return{
      helpImport:null
    }
  },
  mounted(){
    this.helpImport = require('./helpImport_fr.json');
  }
}
</script>

<style>
  @import "../../../../style/App.scss";
  @import "../../../../style/views/frontend/documents/help/helpImport.scss";
</style>